import { useAppSelector } from '@common/hooks/store';
import { userLoggedIn } from '@features/auth/slice/authSlice';
import { useEffect, useState } from 'react';
import './style.css';
import { useLocation } from 'react-router-dom';

const loadBitrixChat = (load: () => void) => {
  if (typeof window === 'undefined') return;
  if ((window as any).BX24ChatLoaded) return;
  (window as any).BX24ChatLoaded = true;
  const script = document.createElement('script');
  script.src = `https://bitrix.formula55.tj/upload/crm/site_button/loader_1_1pn771.js?${(Date.now() / 60000 | 0)}`;
  script.async = true;
  document.body.appendChild(script);
  script.onload = load;
};

export default function BitrixChat() {
  const { pathname } = useLocation();
  const loggedIn = useAppSelector(userLoggedIn);
  const [ ready, setReady ] = useState(false);

  useEffect(() => {
    if (loggedIn) {
      loadBitrixChat(() => setReady(true));
    } else {
      const bx = document.getElementsByClassName('b24-widget-button-position-bottom-right')[0];
      if (bx) {
        bx.classList.remove('b24-show');
      }
    }
  }, [ loggedIn ]);

  useEffect(() => {
    if (ready) {
      const bx = document.getElementsByClassName('b24-widget-button-position-bottom-right')[0];
      if (bx) {
        if (pathname === '/') {
          bx.classList.add('b24-show');
        } else {
          bx.classList.remove('b24-show');
        }
      }
    }
  }, [ pathname, ready ]);

  return null;
}
